import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTPComplianceItemsResponse } from './types';

export function useTPComplianceItems(companyId: number | null) {
  const baseUrl = `tp-compliance-item?companyId=${companyId}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TTPComplianceItemsResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? baseUrl : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
